import { render, staticRenderFns } from "./AlternateNumberDialog.vue?vue&type=template&id=09f85b14"
import script from "./AlternateNumberDialog.vue?vue&type=script&lang=js"
export * from "./AlternateNumberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports